var exports = {
  "k": "x234b8571--9a2e25--container",
  "D": "x234b8571--9a2e25--title",
};

module.exports = exports;
